<template>
  <div class="tab-text" v-if="products != null">
    <section>
      <div style="text-align:right">
        <vs-button @click="onAddTicketDialog()" color="primary" type="filled"
          >Add Ticket</vs-button
        >

        <vs-button
          @click="onSortTicketDialog()"
          color="primary"
          type="border"
          class="ml-2"
          >Sort Ticket</vs-button
        >
      </div>

      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="false"
        :items="products"
        :select-mode="`multi`"
        :fields="ticketolumns"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <!-- <template v-slot:cell(featured_status)="data">
          <vs-switch
            v-model="data.item.featured_status"
            icon-pack="feather"
            vs-icon="icon-star"
            @change="onTicketStatusChanged(data.item)"
          />
        </template> -->

        <template v-slot:cell(publish_status)="data">
          <vs-switch
            v-model="data.item.publish_status"
            icon-pack="feather"
            vs-icon="icon-check"
            @change="onTicketStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(listing_status)="data">
          <vs-switch
            v-model="data.item.listing_status"
            icon-pack="feather"
            vs-icon="icon-check"
            @change="onTicketStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(pro_name)="data">
          <strong>{{ data.item.pro_name }}</strong>
          <!-- <div>{{ data.item.pro_shortdesc }}</div> -->
          <div v-html="data.item.pro_shortdesc" />
        </template>

        <template v-slot:cell(price)="data">
          {{ data.item.price | numFormat("0,0") }}
        </template>

        <template v-slot:cell(fullprice)="data">
          {{ data.item.fullprice | numFormat("0,0") }}
        </template>

        <template v-slot:cell(Quantity)="data">
          <strong>{{ data.item.Quantity | numFormat("0,0") }}</strong>
        </template>

        <template v-slot:cell(Tickets)="data">
          <strong>{{ data.item.Tickets | numFormat("0,0") }}</strong>
        </template>

        <template v-slot:cell(action)="data">
          <div class="d-flex">
            <vs-button
              @click="openTicketDialog(data.item)"
              color="primary"
              type="flat"
              class="px-2"
              >View
            </vs-button>

            <vs-dropdown :vs-trigger-click="true">
              <a class="a-icon" href="#">
                <vs-button color="primary" type="flat" class="ml-3"
                  ><i class="fas fa-ellipsis-v text-grey" style="font-size: 1.5rem"></i>
                </vs-button>
              </a>

              <vs-dropdown-menu :vs-trigger-click="true">
                <vs-dropdown-item class="ellipsis-text">
                  <div
                    class="d-flex align-items-center p-3"
                    @click="deleteTicketDialog(data.item)"
                  >
                    <i class="far fa-trash-alt menu-icon mr-2"></i>
                    <span>Delete</span>
                  </div>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </template>
      </b-table>
    </section>

    <!-- ticket sorting popup -->
    <vs-popup title="Sorting" :active.sync="ticketSortingDialog">
      <div style="min-height: 100px" class="m-5">
        <draggable
          v-model="products"
          @end="onProductSortingEnded"
          tag="ul"
          class="list-group list-group-flush cursor-move"
        >
          <vs-card
            class="starred-page--more flex items-center cursor-pointer"
            v-for="(item, index) in products"
            :key="index"
          >
            <span>{{ item.pro_name }}</span>
          </vs-card>
        </draggable>
      </div>
    </vs-popup>

    <!-- ticket popup -->
    <vs-popup title="Ticket" :active.sync="ticketDialog">
      <div
        style="min-height: 100px;"
        class="m-5"
        v-if="selectedTicket != null && event != null"
      >
        <div class="mt-4" v-if="role == 'so-admin'">
          <span>Thumbnail</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Square artwork with recommended size of 600x600px
          </div>
          <div
            v-if="selectedTicket.poster != null && selectedTicket.poster != ''"
          >
            <img
              :src="selectedTicket.poster"
              :width="imageWidth"
              :height="imageHeight"
            />
          </div>
          <div
            v-if="!selectedTicket.poster"
            style="width: 300px; height: 158px; background-color: #F5F5F5; border-radius: 8px; position: relative;"
          >
            <vs-button
              style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
              color="dark"
              type="border"
              @click="chooseImage('upload')"
            >
              <span>Upload</span>
            </vs-button>
          </div>
          <div
            class="grid-button-upload"
            style="margin-top: 8px;display: grid;grid-template-columns: repeat(2, min-content);grid-gap: 10px;"
          >
            <!-- secondary / border  >> btn-->
            <vs-button
              v-if="selectedTicket.poster"
              color="dark"
              type="border"
              icon="autorenew"
              style="display: flex"
              @click="chooseImage('change')"
            >
              <span>Change</span>
            </vs-button>
            <input
              id="file-upload-img"
              @change="onUploadImages()"
              type="file"
              ref="fileImage"
              :accept="acceptFile"
            />
            <vs-button
              v-if="selectedTicket.poster"
              color="dark"
              type="border"
              icon="delete_forever"
              style="display: flex"
              @click="popupActivo = true"
            >
              Remove
            </vs-button>
            <vs-popup
              classContent="popup-confirm"
              title="Confirm Delete"
              :active.sync="popupActivo"
            >
              <div>Are you sure you want to delete the image?</div>
              <div class="wrap-button">
                <vs-button
                  color="dark"
                  type="border"
                  style="font-size: 12px !important;"
                  @click="popupActivo = false"
                >
                  No
                </vs-button>
                <vs-button
                  color="primary"
                  style="font-size: 12px !important;"
                  @click="removeposter"
                >
                  Yes
                </vs-button>
              </div>
            </vs-popup>
          </div>
          <!-- <vs-upload
				v-if="!selectedTicket.poster || changeImage"
				:multiple="false"
				:automatic="true"
				:single-upload="true"
				:fileName="`file`"
				:limit="1"
				@change="successTicketThumbnailUpload"
				@on-delete="deleteFileLogo"
				accept="image/png, image/jpeg, image/jpg, image/webp"
          /> -->
          <!-- <div
            class="grid-button-upload"
            v-if="selectedTicket.poster || showBtn"
          >
            <vs-button
              color="dark"
              type="flat"
              icon="autorenew"
              style="display: flex"
              @click="changeImagePoster()"
            >
              Change
            </vs-button>
            <vs-button
              color="dark"
              type="flat"
              icon="delete_forever"
              style="display: flex"
              @click="removeposter()"
            >
              Remove
            </vs-button>
          </div> -->
        </div>

        <div>
          <span>Ticket Name</span>
          <div style="font-size:0.75rem; color:#aaa;"></div>
          <vs-input
            v-validate="'required'"
            name="pro_name"
            style="width: 100%"
            v-model="selectedTicket.pro_name"
            placeholder="Eg., General"
            :maxlength="100"
          />
          <span class="text-danger text-sm" v-show="errors.has('pro_name')">
            {{ splitError(errors.first("pro_name"), "pro_name") }}
          </span>
        </div>

        <!-- <div class="mt-4">
          <span>Ticket Shortname</span>
          <div style="font-size:0.75rem; color:#aaa;">
            This displays the ticket name on the dashboard
          </div>
          <vs-input
            v-validate="'required'"
            name="proshortname"
            style="width: 100%"
            v-model="selectedTicket.pro_shortname"
            label-placeholder="Gen, VIP"
            :maxlength="20"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('proshortname')"
          >
          {{ splitError(errors.first('proshortname'), 'proshortname') }}
          </span>
        </div> -->

        <div class="mt-4" v-if="role == 'so-admin'">
          <span>Type</span>
          <div style="font-size:0.75rem; color:#aaa;"></div>
          <!-- <b-form-select
            v-model="selectedTicket.pro_type"
            :options="proTypeList"
          ></b-form-select> -->
          <vs-select
            class="selectExample"
            style="width:100%;"
            v-model="selectedTicket.pro_type"
          >
            <vs-select-item
              :key="c"
              :value="choice.value"
              :text="choice.text"
              v-for="(choice, c) in proTypeList"
            />
          </vs-select>
        </div>

        <div class="mt-4">
          <span>Ticket Short Decs</span>
          <div style="font-size:0.75rem; color:#aaa;">
            List features and benefits that comes with
          </div>
          <vs-textarea
            rows="5"
            style="width: 100%"
            v-model="selectedTicket.pro_shortdesc"
            label-placeholder=" "
          />
        </div>

        <div class="mt-4" v-if="role == 'so-admin'">
          <span>Ticket Long Description</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Use if this text needs to be long. This will be shown as a link to
            view more details in a pop-up
          </div>
          <vs-textarea
            rows="5"
            style="width: 100%"
            v-model="selectedTicket.pro_longdesc"
            label-placeholder=""
          />
        </div>

        <div class="mt-4" v-show="role == 'so-admin'">
          <span>Ticket Group</span>
          <div style="font-size:0.75rem; color:#aaa;">
            This helps group related tickets together
          </div>
          <vs-input style="width: 100%" v-model="selectedTicket.pro_group" />
        </div>

        <div class="mt-4" v-if="role == 'so-admin'">
          <span>Ticket Note</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Note to attendees shown in the Ticket Email
          </div>
          <!-- <vs-textarea
            rows="5"
            style="width: 100%"
            v-model="selectedTicket.ticket_note"
            label-placeholder=""
          /> -->
          <ArticleEditor
            v-model="selectedTicket.ticket_note"
            :config="{
              plugins: ['blockcode'],
              addbarAdd: ['text', 'card'],
              css: '/article-editor/css/',
              format: ['div', 'h1', 'h2', 'h3', 'ul', 'ol'],
              align: {
                left: 'text-left',
                center: 'text-center',
                right: 'text-right',
                justify: 'text-justify'
              }
            }"
          ></ArticleEditor>
        </div>

        <div class="mt-4">
          <span>Quantity</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Number of tickets available for sale
          </div>
          <!-- <vs-input
            v-validate="{ required: true }"
            name="qty"
            onkeypress="return /^[0-9]/i.test(event.key)"
            style="width: 100%"
            v-model="selectedTicket.qty"
            label-placeholder=""
            :description-text="
              `You have ` +
                remain_quantity +
                ` number of tickets left for this event.`
            "
            v-on:blur="validateQuantity()"
          /> -->
          <!-- v-validate="{
              required: true,
              max_value: ((remainQty - (calQtyLeft - qtyDefault)) - Number(selectedTicket.qty)) + Number(selectedTicket.qty),
              min_value: 1
              }" -->
          <vs-input
            v-validate="{
              required: true,
              max_value: `${remainQty -
                (calQtyLeft - qtyDefault) -
                Number(selectedTicket.qty) +
                Number(selectedTicket.qty)}`,
              min_value: 1
            }"
            name="qty"
            onkeypress="return /^[0-9]/i.test(event.key)"
            style="width: 100%"
            v-model="selectedTicket.qty"
            label-placeholder=""
            :description-text="
              `You have ` +
                (remainQty -
                  (calQtyLeft - qtyDefault) -
                  Number(selectedTicket.qty)) +
                ` number of tickets left for this event.`
            "
            v-on:blur="validateQuantity()"
            onpaste="return false"
          />
          <span class="text-danger text-sm" v-show="errors.has('qty')">
            {{ splitError(errors.first("qty"), "qty") }}
          </span>
          <!-- <ul>
            <li class="text-danger text-sm" v-for="error in errors.collect('qty')" :key="error">{{ splitError(error, 'qty') }}</li>
          </ul> -->
          <!-- <vs-checkbox v-model="checkBox1">Unlimited</vs-checkbox> -->
        </div>

        <!-- <div class="mt-4">
          <span>Minimum Quantity</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Minimum number of ticket required to purchase
          </div>
          <vs-input
            v-validate="'required'"
            name="minqty"
            onkeypress="return /^[0-9]/i.test(event.key)"
            style="width: 100%"
            v-model="selectedTicket.minqty"
            label-placeholder=""
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('minqty')"
          >
            {{ errors.first("minqty") }}
          </span>
        </div> -->

        <div class="mt-4" v-if="role == 'so-admin'">
          <span>Access Type</span>
          <div style="font-size:0.75rem; color:#aaa;"></div>
          <ul class="demo-alignment">
            <li>
              <vs-radio
                vs-name="radios-ticket-mode"
                v-model="selectedTicket.mode"
                vs-value="offline"
              >
                Offline - Access the event using a QR Code or a 6-character code
              </vs-radio>
            </li>
            <li>
              <vs-radio
                vs-name="radios-ticket-mode"
                v-model="selectedTicket.mode"
                vs-value="online"
              >
                Online - Access the event using a personalized link
              </vs-radio>
            </li>
            <li>
              <vs-radio
                vs-name="radios-ticket-mode"
                v-model="selectedTicket.mode"
                vs-value="hybrid"
              >
                Hybrid - Provide both online and offline options to access the
                event
              </vs-radio>
            </li>
          </ul>
        </div>

        <div v-if="!event.freeevent">
          <div class="mt-4">
            <span>Selling Price</span>
            <div style="font-size:0.75rem; color:#aaa;">
              If price is lower than full price, it will be shown as a
              discounted price
            </div>
            <vs-input
              v-validate="'required'"
              name="price"
              onkeypress="return /^[0-9.]/i.test(event.key)"
              style="width: 100%"
              v-model="selectedTicket.price"
              label-placeholder=""
              onpaste="return false"
            />
            <span class="text-danger text-sm" v-show="errors.has('price')">
              {{ splitError(errors.first("price"), "price") }}
            </span>
          </div>

          <div class="mt-4">
            <span>Full Price</span>
            <div style="font-size:0.75rem; color:#aaa;">
              Full price of the ticket
            </div>
            <vs-input
              v-validate="'required'"
              name="fullprice"
              onkeypress="return /^[0-9.]/i.test(event.key)"
              style="width: 100%"
              v-model="selectedTicket.fullprice"
              label-placeholder=""
              onpaste="return false"
            />
            <span class="text-danger text-sm" v-show="errors.has('fullprice')">
              {{ splitError(errors.first("fullprice"), "fullprice") }}
            </span>
          </div>
        </div>

        <div class="mt-4">
          <span>Quantity per Pack</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Number of tickets must be purchased <br />
            Eg. During promotion period, buyer must buy at least 2 tickets for
            special price
          </div>
          <vs-input
            v-validate="{ min_value: 1 }"
            name="requiredqty"
            onkeypress="return /^[0-9]/i.test(event.key)"
            style="width: 100%"
            v-model="selectedTicket.requiredqty"
            label-placeholder=""
            onpaste="return false"
          />
          <span class="text-danger text-sm" v-show="errors.has('requiredqty')">
            {{ splitError(errors.first("requiredqty"), "requiredqty") }}
          </span>
          <!-- <ul>
            <li class="text-danger text-sm" v-for="error in errors.collect('requiredqty')" :key="error">{{ splitError(error, 'requiredqty') }}</li>
          </ul> -->
        </div>

        <div class="mt-4">
          <span>Minimum Quantity</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Minimum number of ticket required to purchase
          </div>
          <vs-input
            v-validate="{ min_value: 1 }"
            name="minqty"
            onkeypress="return /^[0-9]/i.test(event.key)"
            style="width: 100%"
            v-model="selectedTicket.minqty"
            label-placeholder=""
            onpaste="return false"
          />
          <!-- <ul>
            <li class="text-danger text-sm" v-for="error in errors.collect('minqty')" :key="error">{{ splitError(error, 'minqty') }}</li>
          </ul> -->
          <span class="text-danger text-sm" v-show="errors.has('minqty')">
            {{ splitError(errors.first("minqty"), "minqty") }}
          </span>
        </div>
        <div class="mt-4">
          <span>Maximum Quantity</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Maximum number of ticket required to purchase
          </div>
          <vs-input
            v-validate="{ min_value: 1 }"
            name="maxqty"
            onkeypress="return /^[0-9]/i.test(event.key)"
            style="width: 100%"
            v-model="selectedTicket.maxqty"
            label-placeholder=""
            onpaste="return false"
          />
          <span class="text-danger text-sm" v-show="errors.has('maxqty')">
            {{ splitError(errors.first("maxqty"), "maxqty") }}
          </span>
          <!-- <ul>
            <li class="text-danger text-sm" v-for="error in errors.collect('maxqty')" :key="error">{{ splitError(error, 'maxqty') }}</li>
          </ul> -->
        </div>

        <div class="mt-4">
          <span>Role</span>
          <vs-input
            style="width: 100%"
            v-model="selectedTicket.role"
            label-placeholder="Speaker, Guest, Judges"
          />
        </div>

        <div class="mt-4">
          <span class="my-2">Registration Period</span>
          <div>
            <el-date-picker
              v-validate="'required'"
              name="daterange"
              style="width: 100%;"
              value-format="yyyy-MM-dd HH:mm"
              format="dd-MM-yyyy HH:mm"
              v-model="dateRegistration"
              type="datetimerange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              popper-class="custom-date-picker"
            ></el-date-picker>
            <span class="text-danger text-sm" v-show="errors.has('daterange')">
              {{ splitError(errors.first("daterange"), "daterange") }}
            </span>
          </div>
          <!-- <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full">
              <flat-pickr
                v-validate="'required'"
                name="selldate_start"
                v-model="selectedTicket.selldate_start"
                class="form-control"
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('selldate_start')"
              >
                {{ splitError(errors.first("selldate_start"), 'selldate_start') }}
              </span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <flat-pickr
                v-validate="'required'"
                name="selldate_end"
                v-model="selectedTicket.selldate_end"
                class="form-control"
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('selldate_end')"
              >
                {{ splitError(errors.first('selldate_end'), 'selldate_end') }}
              </span>
            </div>
          </div> -->
        </div>

        <section v-if="role == 'so-admin'">
          <div class="mt-4">
            <div class="my-2">Registration Status</div>
            <div style="font-size:0.75rem; color:#aaa;"></div>
            <ul class="demo-alignment">
              <li>
                <vs-radio
                  v-model="selectedTicket.sell_status"
                  vs-name="radios-selectedTicketsell_status"
                  :vs-value="`open`"
                  >Open</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="selectedTicket.sell_status"
                  vs-name="radios-selectedTicketsell_status"
                  :vs-value="`closed`"
                  >Closed</vs-radio
                >
              </li>
              <li>
                <vs-radio
                  v-model="selectedTicket.sell_status"
                  vs-name="radios-selectedTicketsell_status"
                  :vs-value="`soldoutt`"
                  >SOLDOUTT</vs-radio
                >
              </li>
            </ul>
          </div>

          <div class="mt-4">
            <div class="vx-col w-full">
              <div class="my-2">Status</div>
              <div style="font-size:0.75rem; color:#aaa;"></div>
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    vs-name="radios-selectedTicketpublish_status"
                    v-model="selectedTicket.publish_status"
                    vs-value="1"
                    >Enabled</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    vs-name="radios-selectedTicketpublish_status"
                    v-model="selectedTicket.publish_status"
                    vs-value="0"
                    >Disabled</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>

          <div class="mt-4">
            <div class="vx-colw-full">
              <div class="my-2">Visibility</div>
              <div style="font-size:0.75rem; color:#aaa;"></div>
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    vs-name="radios-selectedTicketlisting_status"
                    v-model="selectedTicket.listing_status"
                    vs-value="1"
                    >Visible - Listed on the Register page</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    vs-name="radios-selectedTicketlisting_status"
                    v-model="selectedTicket.listing_status"
                    vs-value="0"
                    >Hidden - Only accessible via a special link</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>

          <div class="mt-4">
            <div class="vx-col w-full">
              <div>Featured</div>
              <div style="font-size:0.75rem; color:#aaa;">
                Pin this at the top of the list
              </div>
              <ul class="demo-alignment">
                <li>
                  <vs-radio
                    vs-name="radios-selectedTicketfeatured_status"
                    v-model="selectedTicket.featured_status"
                    vs-value="1"
                    >Yes</vs-radio
                  >
                </li>
                <li>
                  <vs-radio
                    vs-name="radios-selectedTicketfeatured_status"
                    v-model="selectedTicket.featured_status"
                    vs-value="0"
                    >No</vs-radio
                  >
                </li>
              </ul>
            </div>
          </div>
        </section>

        <div class="vx-row my-6" v-if="selectedTicket.product_id != null">
          <span v-if="selectedTicket.updated_at && selectedTicket.updated_by">
            Updated by {{ selectedTicket.updated_by.name }} at {{ selectedTicket.updated_at }}
          </span>
          <span v-else>
            Updated at {{ selectedTicket.updated_at }}
          </span>
        </div>
        <vs-divider></vs-divider>

        <h2>Advanced</h2>

        <div class="mt-4">
          <span>Ticket Slug</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Used as unique identifier for the ticket type
          </div>
          <vs-input
            v-validate="{ required: true }"
            name="slug"
            style="width: 100%"
            v-model="selectedTicket.slug"
            label-placeholder="Eg., general"
            v-on:keyup="validateTicketSlug()"
          />
          <span class="text-danger text-sm" v-show="errors.has('slug')">
            {{ splitError(errors.first("slug"), "slug") }}
          </span>
        </div>

        <div class="mt-4" v-if="role == 'so-admin'">
          <span>Ticket Group Slug</span>
          <div style="font-size:0.75rem; color:#aaa;">
            Used as unique identifier for the ticket group
          </div>
          <vs-input
            style="width: 100%"
            v-model="selectedTicket.groupslug"
            label-placeholder=""
            v-on:keyup="validateTicketSlug()"
          />
        </div>

        <div class="mt-4">
          <span>Weight</span>
          <div style="font-size:0.75rem; color:#aaa;"></div>
          <vs-input
            style="width: 100%"
            v-model="selectedTicket.weight"
            label-placeholder=""
            onkeypress="return /^[0-9]/i.test(event.key)"
            onpaste="return false"
          />
        </div>

        <vs-divider></vs-divider>
        <div class="vx-row pt-2 mt-0">
          <div class="vx-col w-full ml-auto">
            <vs-button
              class="mr-3 mb-2"
              color="primary"
              type="filled"
              @click="validateForm"
              >Save</vs-button
            >

            <vs-button
              class="mr-3 mb-2"
              type="border"
              @click="ticketDialog = false"
              >Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      classContent="popup-confirm"
      title="Confirm Delete"
      :active.sync="deleteDialog"
    >
      <div>Are you sure you want to delete the ticket?</div>
      <div class="wrap-button">
        <vs-button
          color="dark"
          type="border"
          style="font-size: 12px !important;"
          @click="deleteDialog = false"
        >
          No
        </vs-button>
        <vs-button
          color="primary"
          style="font-size: 12px !important;"
          @click="onDeleteTicket()"
        >
          Yes
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import moment from "moment";
// import { mapState } from "vuex";
import Service from "@/services";

import draggable from "vuedraggable";

import { ticketForm } from "@/utils/eventForm";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import ArticleEditor from "@/components/ArticleEditor.vue";

export default {
  components: {
    draggable,
    flatPickr,
    ArticleEditor
  },
  props: {
    event: {
      freeevent: null
    },
    role: null,
    folder: null,
    products: null,
    remainQty: null
  },
  data() {
    return {
      popupActivo: false,
      ticketSortingDialog: false,
      ticketDialog: false,
      deleteDialog: false,
      selectedTicket: null,
      remain_quantity: 0,
      ticketThumbnailUploadUrl:
        process.env.VUE_APP_API_URL + "/events/" + this.folder + "/upload",
      ticketThumbnailUploadHeader: {
        Authorization:
          "Bearer " +
          JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
      },
      ticketData: {
        type: "ticket"
      },
      ticketolumns: [
        { label: "ID", key: "product_id", sortable: false },
        // { label: "Featured Status", key: "featured_status", sortable: false },
        { label: "Registration Status", key: "sell_status", sortable: false },
        { label: "Name", key: "pro_name", sortable: false },
        { label: "Price", key: "price", sortable: false },
        { label: "Full Price", key: "fullprice", sortable: false },
        { label: "Quantity", key: "Quantity", sortable: false },
        { label: "Sold", key: "Tickets", sortable: false },
        { label: "Action", key: "action", sortable: false }
      ],
      proTypeList: [
        { text: "Tickets to events", value: "event" },
        { text: "Booths at events", value: "booth" },
        { text: "Products", value: "product" },
        { text: "Vouchers for food or services", value: "voucher" },
        { text: "Educational Courses", value: "course" },
        { text: "Online Courses", value: "onlinecourse" },
        { text: "Memberships", value: "member" }
      ],
      poster: null,
      // totalQty: 0
      qtyDefault: 0,
      changeImage: false,
      imageWidth: 0,
      imageHeight: 0,
      showBtn: false,
      acceptFile: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
      posterTicket: null,
      dateRegistration: []
    };
  },
  computed: {
    calQtyLeft() {
      const remain = this.products.map(ele => ele.Quantity);
      const initialValue = 0;
      const sumWithInitial = remain.reduce(
        (previousValue, currentValue) => previousValue + currentValue,
        initialValue
      );
      return sumWithInitial;
    }
  },
  watch: {
    "selectedTicket.qty"(val) {
      return Number(val);
    }
    // 'totalQty' (val) {
    //   return this.remainQty - (this.calQtyLeft + this.selectedTicket.qty)
    // }
  },
  methods: {
    splitError(val, word) {
      if (!val) {
        return;
      } else {
        const data = val.split(word);
        return data[0] + data[1];
      }
    },
    onSortTicketDialog() {
      this.ticketSortingDialog = true;
    },
    onAddTicketDialog() {
      this.poster = null;
      this.selectedTicket = {
        ...ticketForm,
        poster: "",
        pro_name: null,
        pro_shortname: null,
        slug: null
      };
      this.ticketDialog = true;
      this.$validator.reset();
      this.dateRegistration = [];
      this.selectedTicket.pro_type = "event";
      this.selectedTicket.selldate_start = moment().format("YYYY-MM-DD HH:mm");
      this.selectedTicket.selldate_end = moment().format("YYYY-MM-DD HH:mm");
      this.selectedTicket.mode = "offline";
      this.selectedTicket.price = null;
      this.selectedTicket.fullprice = null;
      this.selectedTicket.requiredqty = null;
      this.selectedTicket.maxqty = null;
      this.selectedTicket.minqty = null;
      this.selectedTicket.qty = null;
      this.selectedTicket.role = null;
      this.qtyDefault = 0;
    },
    openTicketDialog(item) {
      Service.Event.getProduct(this.event.slug, item.product_id).then(res => {
        let publish_status = 0;
        if (res.data.rows[0].publish_status) {
          publish_status = 1;
        }

        let featured_status = 0;
        if (res.data.rows[0].featured_status) {
          featured_status = 1;
        }

        let listing_status = 0;
        if (res.data.rows[0].listing_status) {
          listing_status = 1;
        }

        this.selectedTicket = {
          ...res.data.rows[0],
          defaultQuantity: item.Quantity,
          sold: item.Tickets,
          remain_quantity: this.remain_quantity,
          publish_status: publish_status,
          featured_status: featured_status,
          listing_status: listing_status,
          pro_group:
            res.data.rows[0].pro_group === null
              ? null
              : res.data.rows[0].pro_group === "null"
              ? null
              : res.data.rows[0].pro_group,
          pro_shortdesc:
            res.data.rows[0].pro_shortdesc === null
              ? null
              : res.data.rows[0].pro_shortdesc === "null"
              ? null
              : res.data.rows[0].pro_shortdesc,
          pro_longdesc:
            res.data.rows[0].pro_longdesc === null
              ? null
              : res.data.rows[0].pro_longdesc === "null"
              ? null
              : res.data.rows[0].pro_longdesc,
          ticket_note:
            res.data.rows[0].ticket_note === null
              ? null
              : res.data.rows[0].ticket_note === "null"
              ? null
              : res.data.rows[0].ticket_note,
          role:
            res.data.rows[0].role === null
              ? null
              : res.data.rows[0].role === "null"
              ? null
              : res.data.rows[0].role,
          slug:
            res.data.rows[0].slug === null
              ? null
              : res.data.rows[0].slug === "null"
              ? null
              : res.data.rows[0].slug,
          groupslug:
            res.data.rows[0].groupslug === null
              ? null
              : res.data.rows[0].groupslug === "null"
              ? null
              : res.data.rows[0].groupslug,
          mode:
            res.data.rows[0].mode === "0" || res.data.rows[0].mode === null
              ? "offline"
              : res.data.rows[0].mode,
          requiredqty: res.data.rows[0].requiredqty,
          maxqty: res.data.rows[0].maxqty,
          minqty: res.data.rows[0].minqty
        };
        this.dateRegistration = [
          res.data.rows[0].selldate_start,
          res.data.rows[0].selldate_end
        ];

        this.qtyDefault = this.selectedTicket.qty;

        // this.selectedTicket.poster = res.data.rows[0].poster ? res.data.rows[0].poster: null
        this.ticketDialog = true;
        this.setImageSize();
      });
    },
    deleteTicketDialog(item) {
      Service.Event.getProduct(this.event.slug, item.product_id).then(res => {
        let publish_status = 0;
        if (res.data.rows[0].publish_status) {
          publish_status = 1;
        }

        let featured_status = 0;
        if (res.data.rows[0].featured_status) {
          featured_status = 1;
        }

        let listing_status = 0;
        if (res.data.rows[0].listing_status) {
          listing_status = 1;
        }

        this.selectedTicket = {
          ...res.data.rows[0],
          defaultQuantity: item.Quantity,
          sold: item.Tickets,
          remain_quantity: this.remain_quantity,
          publish_status: publish_status,
          featured_status: featured_status,
          listing_status: listing_status,
          pro_group:
            res.data.rows[0].pro_group === null
              ? null
              : res.data.rows[0].pro_group === "null"
              ? null
              : res.data.rows[0].pro_group,
          pro_shortdesc:
            res.data.rows[0].pro_shortdesc === null
              ? null
              : res.data.rows[0].pro_shortdesc === "null"
              ? null
              : res.data.rows[0].pro_shortdesc,
          pro_longdesc:
            res.data.rows[0].pro_longdesc === null
              ? null
              : res.data.rows[0].pro_longdesc === "null"
              ? null
              : res.data.rows[0].pro_longdesc,
          ticket_note:
            res.data.rows[0].ticket_note === null
              ? null
              : res.data.rows[0].ticket_note === "null"
              ? null
              : res.data.rows[0].ticket_note,
          role:
            res.data.rows[0].role === null
              ? null
              : res.data.rows[0].role === "null"
              ? null
              : res.data.rows[0].role,
          slug:
            res.data.rows[0].slug === null
              ? null
              : res.data.rows[0].slug === "null"
              ? null
              : res.data.rows[0].slug,
          groupslug:
            res.data.rows[0].groupslug === null
              ? null
              : res.data.rows[0].groupslug === "null"
              ? null
              : res.data.rows[0].groupslug,
          mode:
            res.data.rows[0].mode === "0" || res.data.rows[0].mode === null
              ? "offline"
              : res.data.rows[0].mode,
          requiredqty: res.data.rows[0].requiredqty,
          maxqty: res.data.rows[0].maxqty,
          minqty: res.data.rows[0].minqty
        };
        // this.dateRegistration = [
        //   res.data.rows[0].selldate_start,
        //   res.data.rows[0].selldate_end
        // ];

        // this.qtyDefault = this.selectedTicket.qty;

        // this.selectedTicket.poster = res.data.rows[0].poster ? res.data.rows[0].poster: null
        this.deleteDialog = true;
        // this.setImageSize();
      });
    },
    removeposter() {
      this.selectedTicket.poster = null;
      const formData = new FormData();
      formData.append("remove", "poster");

      if (this.selectedTicket.update_date) {
        Service.Product.update(formData, this.selectedTicket.product_id)
          .then(res => {
            this.$emit("loadEvent");
            this.changeImage = false;
            this.selectedTicket.poster = res.data.product.poster;
          })
          .catch(() => {});
      }
    },
    validateForm() {
      this.selectedTicket.pro_shortname = this.selectedTicket.pro_name;
      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.onUpdateTicket();
        }
      });
    },
    setImageSize() {
      let posterimage = document.querySelector("img");
      let w = posterimage.naturalWidth;
      let h = posterimage.naturalHeight;
      this.imageHeight = h;
      this.imageWidth = w;

      if (w > h) {
        this.imageWidth = 300;
        this.imageHeight = "auto";
      } else {
        this.imageHeight = 300;
        this.imageWidth = "auto";
      }
    },
    onUpdateTicket() {
      this.selectedTicket = {
        ...this.selectedTicket,
        s: this.event.merchant.s,
        e: this.event.slug,
        slug: this.generateSlug(this.selectedTicket.slug),
        poster: this.poster,
        pro_group:
          this.selectedTicket.pro_group === null
            ? ""
            : this.selectedTicket.pro_group === "null"
            ? ""
            : this.selectedTicket.pro_group,
        pro_shortdesc:
          this.selectedTicket.pro_shortdesc === null
            ? ""
            : this.selectedTicket.pro_shortdesc === "null"
            ? ""
            : this.selectedTicket.pro_shortdesc,
        pro_longdesc:
          this.selectedTicket.pro_longdesc === null
            ? ""
            : this.selectedTicket.pro_longdesc === "null"
            ? ""
            : this.selectedTicket.pro_longdesc,
        ticket_note:
          this.selectedTicket.ticket_note === null
            ? ""
            : this.selectedTicket.ticket_note === "null"
            ? ""
            : this.selectedTicket.ticket_note,
        role:
          this.selectedTicket.role === null
            ? ""
            : this.selectedTicket.role === "null"
            ? null
            : this.selectedTicket.role,
        groupslug:
          this.selectedTicket.groupslug === null
            ? ""
            : this.selectedTicket.groupslug === "null"
            ? ""
            : this.selectedTicket.groupslug,
        weight:
          this.selectedTicket.weight === ""
            ? 0
            : Number(this.selectedTicket.weight)
      };

      // dateRegistration: []

      this.selectedTicket.selldate_start = moment(
        // this.selectedTicket.selldate_start
        this.dateRegistration[0]
      ).format("YYYY-MM-DD HH:mm");
      this.selectedTicket.selldate_end = moment(
        // this.selectedTicket.selldate_end
        this.dateRegistration[1]
      ).format("YYYY-MM-DD HH:mm");

      const formData = new FormData();
      const dataKeyForms = Object.keys(this.selectedTicket);
      for (let index = 0; index < dataKeyForms.length; index++) {
        const key = dataKeyForms[index];
        const value = this.selectedTicket[key];
        formData.append(key, value);
      }

      if (this.selectedTicket.product_id != null) {
        Service.Product.update(formData, this.selectedTicket.product_id)
          .then(() => {
            this.ticketDialog = false;
            this.selectedTicket = null;
            this.$emit("loadEvent");
            // if (res.success) {
            //   this.ticketDialog = false;
            //   this.selectedTicket = null;
            //   // this.loadEvent();

            //   this.$emit("loadEvent");
            // }
          })
          .catch(() => {});
      } else {
        Service.Product.add(formData)
          .then(res => {
            this.ticketDialog = false;
            this.$emit("loadEvent");
            // if (res.success) {
            //   this.ticketDialog = false;
            //   this.selectedTicket = {
            //     ...ticketForm,
            //     poster: "",
            //     // poster: "",
            //     // product_id: null,
            //     // pro_name: "",
            //     // pro_shortname: "",
            //     // pro_shortdesc: "",
            //     // qty: 0,
            //     // price: 0,
            //     // fullprice: 0,
            //     // selldate_start: moment().format("YYYY-MM-DD HH:mm"),
            //     // selldate_end: moment().format("YYYY-MM-DD HH:mm"),
            //     // requiredqty: 1,
            //     // minqty: 1,
            //     // maxqty: 1,
            //     // publish_status: null,
            //     // listing_status: null,
            //     // weight: 0
            //   };
            //   this.$emit("loadEvent");
            // }
          })
          .catch(() => {});
      }
    },
    onDeleteTicket() {
      this.selectedTicket = {
        product_id: this.selectedTicket.product_id,
        s: this.event.merchant.s,
        e: this.event.slug,
        trash_status: 1
      };
      const formData = new FormData();
      const dataKeyForms = Object.keys(this.selectedTicket);
      for (let index = 0; index < dataKeyForms.length; index++) {
        const key = dataKeyForms[index];
        const value = this.selectedTicket[key];
        formData.append(key, value);
      }

      if (this.selectedTicket.product_id != null) {
        Service.Product.trash(formData, this.selectedTicket.product_id)
          .then(() => {
            this.deleteDialog = false;
            this.selectedTicket = null;
            this.$emit("loadEvent");
            // if (res.success) {
            //   this.ticketDialog = false;
            //   this.selectedTicket = null;
            //   // this.loadEvent();

            //   this.$emit("loadEvent");
            // }
          })
          .catch(() => {});
      }
    },
    changeImagePoster() {
      this.changeImage = true;
      this.showBtn = true;
    },
    successTicketThumbnailUpload(res, file) {
      // const data = JSON.parse(res.currentTarget.response)
      // // console.log(data.data.path, 'post')
      //   this.poster = data.data.path
      //   // this.$vs.notify({
      //   //     color: "success",
      //   //     title: "Upload Success",
      //   //     text: "Poster upload success!"
      //   //   });
      // Service.Event.get(this.folder)
      //   .then(res => {
      //     // this.event = res.data.event;
      //     this.$vs.notify({
      //       color: "success",
      //       title: "Upload Success",
      //       text: "Poster upload success!"
      //     });
      //   })
      //   .catch(e => {
      //     /* this.$router.push("/pages/error-404").catch(() => {}); */
      //   });
      // this.selectedTicket.poster = null
      this.poster = file[0];
      if (this.selectedTicket.product_id != null) {
        this.showBtn = true;
        this.changeImage = false;
        this.updatePoster();
      }
    },
    updatePoster() {
      const formData = new FormData();
      formData.append("poster", this.poster);

      Service.Product.update(formData, this.selectedTicket.product_id)
        .then(res => {
          this.$emit("loadEvent");
          this.changeImage = false;
          this.selectedTicket.poster = res.data.product.poster;
        })
        .catch(() => {});
    },
    deleteFileLogo(res) {
      this.poster = null;
    },
    validateTicketSlug() {
      var slugify = require("slugify");
      this.selectedTicket.slug = slugify(this.selectedTicket.slug, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false // strip special characters except replacement, defaults to `false`
      });
      if (this.selectedTicket.slug.match(/(\w+)/g).length > 5) {
        var words = this.selectedTicket.slug.split("-");
        this.selectedTicket.slug =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
    },
    validateQuantity() {
      /*
      if (
        parseInt(this.selectedTicket.qty) < parseInt(this.selectedTicket.sold)
      ) {
        if (this.selectedTicket.defaultQuantity) {
          this.selectedTicket.qty = this.selectedTicket.defaultQuantity;
        } else {
          this.selectedTicket.qty = this.selectedTicket.remain_quantity;
        }
        alert("Quantity should greater than ticket sold.");
      } else if (
        parseInt(this.selectedTicket.qty) >
        parseInt(this.selectedTicket.remain_quantity)
      ) {
        if (this.selectedTicket.defaultQuantity) {
          this.selectedTicket.qty = this.selectedTicket.defaultQuantity;
        } else {
          this.selectedTicket.qty = this.selectedTicket.remain_quantity;
        }
        alert("Quantity should lower than remaining quota.");
      }
      */
    },
    generateSlug(value) {
      var slugify = require("slugify");

      let word = slugify(value, {
        replacement: "-", // replace spaces with replacement character, defaults to `-`
        remove: /[*#+~%^&*.()๋ัฤ็ฺ๋?ฦ๐ํ๊ฯ,ๆำๅกขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรลวศษสอหฬฮะาิีุูึ์ ืแโใไ๑๒๓๔ู฿๕๖๗๘๙่เ้'"!:@=]/g, // remove characters that match regex, defaults to `undefined`
        lower: true, // convert to lower case, defaults to `false`
        strict: false // strip special characters except replacement, defaults to `false`
      });

      if (word.match(/(\w+)/g).length > 5) {
        var words = word.split("-");
        word =
          words[0] +
          "-" +
          words[1] +
          "-" +
          words[2] +
          "-" +
          words[3] +
          "-" +
          words[4];
      }
      return word;
    },
    chooseImage(val) {
      if (val === "change") {
        document.getElementById("file-upload-img").click();
      } else {
        document.getElementById("file-upload-img").click();
      }
    },
    onUploadImages() {
      console.log("object");
      // this.basicForm.poster = this.$refs.fileImage.files[0]
      this.poster = this.$refs.fileImage.files[0];
      this.selectedTicket.poster = this.$refs.fileImage.files[0];
      const reader = new FileReader();
      reader.onloadend = async () => {
        this.selectedTicket.poster = reader.result;
        if (this.selectedTicket.update_date) {
          this.updatePoster(this.poster);
        }
        this.setImageSize();
        // var str = reader.result.split(',')[1]
        // var image = this.b64toBlob(str, "image/jpeg")
        // var imgURL = URL.createObjectURL(image)
        // this.posterUpdate = imgURL
        // this.basicForm.poster = reader.result
      };
      reader.readAsDataURL(this.$refs.fileImage.files[0]);
      this.$refs.fileImage.value = null;
    },
    onProductSortingEnded: _.debounce(function(e) {
      let sorted = this.products.map((item, index) => {
        return {
          product_id: item.product_id,
          pro_name: item.pro_name,
          publish_status: item.publish_status,
          listing_status: item.listing_status,
          featured_status: item.featured_status,
          pro_longdesc: item.pro_longdesc,
          pro_shortdesc: item.pro_shortdesc,
          ticket_note: item.ticket_note,
          weight: 10000 - (index + 1) * 100
        };
      });
      sorted.map(item => {
        Service.Product.update(item, item.product_id).then(res => {});
      });

      this.$vs.notify({
        title: "Success",
        text: "Update complete.",
        color: "success"
      });
    }, 500),
    onTicketStatusChanged: _.debounce(function(e) {
      this.$vs.loading();

      let data = {
        product_id: e.product_id,
        publish_status: 1,
        listing_status: 1,
        featured_status: 1
      };

      if (!e.publish_status) {
        data.publish_status = null;
      }
      if (!e.listing_status) {
        data.listing_status = null;
      }
      // if (!e.featured_status) {
      //   data.featured_status = null;
      // }

      Service.Product.update(data).then(res => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
        }

        this.$vs.loading.close();
      });
    }, 500)
  }
};
</script>
<style lang="scss" scoped>
.grid-button-upload {
  margin-top: 8px;
  display: grid;
  grid-template-columns: repeat(2, min-content);
  grid-gap: 10px;
}
.vs-button {
  font-size: 10px !important;
}
input[type="file"] {
  display: none !important;
}

.popup-confirm {
  & div {
    width: 100%;
    text-align: center;
  }
  & .wrap-button {
    display: grid;
    grid-template-columns: repeat(2, 25%);
    grid-gap: 8px;
    justify-content: flex-end;
    margin-top: 20px;
  }
}
</style>
